<template>
  <div class="min-h-screen bg-gray-50 py-10 px-4 md:px-8 lg:py-16">
    <!-- Navegação superior (apenas desktop) -->
    <div class="hidden lg:flex max-w-6xl mx-auto mb-6 justify-between items-center">
      <router-link
        to="/"
        class="group flex items-center text-[#005baa] hover:text-[#004a8c] transition-colors duration-300"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 transition-transform duration-300 group-hover:-translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
        <span class="font-medium">Voltar para Informes</span>
      </router-link>
      

    </div>

    <div class="max-w-4xl lg:max-w-6xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300">
      <div v-if="informe" class="relative">
                  <!-- Botão Voltar (apenas mobile e tablet) -->
                  <router-link
            to="/"
            class="lg:hidden group flex items-center justify-center bg-[#005baa] text-white px-4 py-2 rounded-md shadow-md hover:bg-[#004a8c] transition-all duration-300 mb-6 w-auto inline-block"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 transition-transform duration-300 group-hover:-translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            <span>Voltar</span>
          </router-link>
        <!-- Imagem de destaque com overlay gradiente aprimorado -->
        <div v-if="informe.imagem_base64" class="w-full h-64 md:h-80 lg:h-96 relative overflow-hidden">
          <img
            :src="informe.imagem_base64"
            alt="Imagem do Informe"
            class="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
          
          <!-- Título sobre a imagem com melhor legibilidade -->
          <div class="absolute bottom-0 left-0 p-6 md:p-8 lg:p-10 w-full">
            <h1 class="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-3 drop-shadow-lg">
              {{ informe.titulo }}
            </h1>
            <div class="flex flex-wrap items-center text-white/90 text-sm lg:text-base space-x-4">
              <span class="flex items-center backdrop-blur-sm bg-black/20 px-3 py-1 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                {{ formatDate(informe.data_publicacao) }}
              </span>
              <span v-if="informe.criado_por" class="flex items-center backdrop-blur-sm bg-black/20 px-3 py-1 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {{ informe.criado_por }}
              </span>
              <span v-if="informe.data_expiracao" class="flex items-center backdrop-blur-sm bg-black/20 px-3 py-1 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Expira: {{ formatDate(informe.data_expiracao) }}
              </span>
            </div>
          </div>
        </div>
        
        <!-- Cabeçalho sem imagem aprimorado -->
        <div v-else class="border-b border-gray-200 px-6 py-8 md:py-10 lg:py-12 lg:px-10 bg-gradient-to-r from-[#004a8c] via-[#005baa] to-[#0075d9]">
          <h1 class="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 drop-shadow-sm">
            {{ informe.titulo }}
          </h1>
          <div class="flex flex-wrap items-center text-white/90 text-sm lg:text-base gap-3">
            <span class="flex items-center bg-white/10 px-3 py-1 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              {{ formatDate(informe.data_publicacao) }}
            </span>
            <span class="flex items-center bg-white/10 px-3 py-1 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              {{ informe.criado_por }}
            </span>
            <span v-if="informe.data_expiracao" class="flex items-center bg-white/10 px-3 py-1 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Expira: {{ formatDate(informe.data_expiracao) }}
            </span>
          </div>
        </div>

        <!-- Layout de conteúdo aprimorado para desktop -->
        <div class="p-6 md:p-8 lg:p-10">


          <!-- Layout de duas colunas para desktop -->
          <div class="lg:flex lg:gap-8">
            <!-- Coluna principal -->
            <div class="lg:flex-1">
              <!-- Resumo com destaque aprimorado -->
              <div class="bg-blue-50 border-l-4 border-[#005baa] p-5 lg:p-6 rounded-r-md mb-8 shadow-sm">
                <p class="text-gray-700 leading-relaxed lg:text-lg">{{ informe.resumo }}</p>
              </div>

              <!-- Conteúdo Completo -->
              <div class="prose prose-lg lg:prose-xl max-w-none text-gray-800 mt-8 whitespace-pre-line">
                {{ informe.conteudo }}
              </div>
            </div>
            

          </div>
        </div>
      </div>

      <!-- Estado de carregamento aprimorado -->
      <div v-else class="p-16 lg:p-24 text-center">
        <div class="inline-block animate-spin rounded-full h-14 w-14 border-4 border-[#005baa] border-t-transparent mb-6"></div>
        <p class="text-gray-600 text-lg font-medium">Carregando informe...</p>
        <p class="text-gray-500 text-sm mt-2">Aguarde enquanto buscamos as informações</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const informe = ref(null);

// Carrega o informe pelo ID da rota
onMounted(async () => {
  try {
    const response = await fetch(`/api/v1/news/article/${route.params.id}`);
    const data = await response.json();
    informe.value = data;
  } catch (err) {
    console.error('Erro ao buscar informe:', err);
  }
});

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('pt-BR');
};
</script>

<style scoped>
.prose {
  line-height: 1.8;
  color: #374151;
}

.prose p {
  margin-bottom: 1.5em;
}

.prose h1, .prose h2, .prose h3, .prose h4 {
  color: #004a8c;
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.75em;
}

.prose a {
  color: #0075d9;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color 0.2s;
}

.prose a:hover {
  color: #004a8c;
}

.prose ul, .prose ol {
  padding-left: 1.5em;
  margin-bottom: 1.5em;
}

.prose li {
  margin-bottom: 0.5em;
}

.prose blockquote {
  border-left: 4px solid #0075d9;
  padding-left: 1em;
  font-style: italic;
  color: #4b5563;
  margin: 1.5em 0;
}

/* Estilos específicos para desktop */
@media (min-width: 1024px) {
  .prose {
    font-size: 1.125rem;
  }
  
  .prose h1 {
    font-size: 2.25rem;
  }
  
  .prose h2 {
    font-size: 1.75rem;
  }
  
  .prose h3 {
    font-size: 1.5rem;
  }
  
  .prose blockquote {
    margin: 2em 0;
    padding-left: 1.5em;
  }
}

@media (max-width: 640px) {
  .prose {
    font-size: 1rem;
  }
}
</style>